import React from "react";
import { useTranslation } from "react-i18next";
import "../../styles/auth.css";

const LoadingState = () => {
  const { t } = useTranslation();

  return (
    <div className="loading-state">
      <div className="loading-content">
        <div className="loader-icon">
          <svg className="spinner-svg" viewBox="0 0 50 50">
            <defs>
              <linearGradient
                id="gradient-spinner"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop
                  offset="0%"
                  style={{ stopColor: "#cc2126", stopOpacity: 1 }}
                />
                <stop
                  offset="100%"
                  style={{ stopColor: "#a81b1f", stopOpacity: 1 }}
                />
              </linearGradient>
            </defs>
            <circle
              className="spinner-circle"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke="url(#gradient-spinner)"
              strokeWidth="2"
            />
          </svg>
        </div>
        <h2 className="loading-title">{t('loading.initializingApp')}</h2>
      </div>
    </div>
  );
};

export default LoadingState;
